<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M 22.8 18.8 C 23.463 18.8 24 19.337 24 20 C 24 20.663 23.463 21.2 22.8 21.2 L 1.2 21.2 C 0.537 21.2 0 20.663 0 20 C 0 19.337 0.537 18.8 1.2 18.8 L 22.8 18.8 Z M 12.6 2.8 C 13.373 2.8 14 3.427 14 4.2 L 14 5.4 C 14 5.675 13.921 5.932 13.784 6.148 C 18.9 6.997 22.8 11.443 22.8 16.8 L 22.8 17.6 L 1.2 17.6 L 1.2 16.8 C 1.2 11.443 5.1 6.997 10.216 6.147 C 10.079 5.932 10 5.675 10 5.4 L 10 4.2 C 10 3.427 10.627 2.8 11.4 2.8 L 12.6 2.8 Z M 12 7.6 C 7.276 7.6 3.383 11.161 2.86 15.746 L 2.834 16 L 21.165 16 L 21.14 15.746 C 20.627 11.248 16.87 7.735 12.267 7.604 L 12 7.6 Z"
      color="currentColor"
    ></path>
  </svg>
</template>
